<template>
  <b-modal
    ref="modal"
    title="Replace or upload as new file:"
    centered
    @hide="closeHandler"
    @ok="ok"
  >
    One or more items already exists in this location. Do you want to replace the existing items with a new version or keep both items?

    <ul 
      class="text-break"
    >
      <li
        v-for="file in files"
        :key="file.id"
      >
        {{ file.data?.name_only }}
      </li>
    </ul>

    <b-form-group>
      <b-form-radio
        v-model="selected"
        :value="FILE_EXISTS_ACTIONS.REPLACE"
      >
        Replace existing items
      </b-form-radio>
      <b-form-radio
        v-model="selected"
        :value="FILE_EXISTS_ACTIONS.KEEP_BOTH"
      >
        Keep all items
      </b-form-radio>
      <b-form-radio
        v-model="selected"
        :value="FILE_EXISTS_ACTIONS.STOP"
      >
        Stop
      </b-form-radio>
    </b-form-group>
  </b-modal>
</template>

<script>
import mixinModal from "./mixin";
import { FILE_EXISTS_ACTIONS } from "../constants";
import { createNamespacedHelpers } from 'vuex'

const { mapActions } = createNamespacedHelpers('fileBrowser')

export default {
  name: "FileExistsModal",
  mixins: [
    mixinModal
  ],
  props: {
    payload: {
      type: Object,
      default: () => ({
        files: []
      })
    }
  },
  data: () => ({
    FILE_EXISTS_ACTIONS,
    selected: FILE_EXISTS_ACTIONS.KEEP_BOTH,
  }),
  computed: {
    files() {
      return this.payload?.files || []
    }
  },
  methods: {
    ...mapActions([
      'uploadFiles',
      'uploadFilesToFolder'
    ]),
    async ok() {
      // Stop cancels the duplicate upload before any preparation or transfer request.
      if (!this.files.length || this.selected === FILE_EXISTS_ACTIONS.STOP) {
        return;
      }

      try {
        const files = this.files.map(({ file, company_id }) => {
          file.company_id = company_id;
          return file;
        });
        if (this.payload.uploadContext) {
          // Keep the embedded picker's folder and incremental update callbacks on duplicates.
          await this.uploadFilesToFolder({
            ...this.payload.uploadContext,
            files,
            replace: this.selected,
          });
        } else {
          await this.uploadFiles({ files, replace: this.selected });
        }
      } catch (error) {
        console.error('Failed to upload files:', error);
        this.$bvToast.toast('Failed to upload files. Please try again.', {
          title: 'Upload Error',
          variant: 'danger',
          solid: true
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
